import types from '../mutation-types';
import {
  conversationBotSettingsAPI,
  inboxBotSettingsAPI,
} from '../../api/botPersonas';
import { throwErrorMessage } from '../utils/api';

export const state = {
  settings: {},
  inboxSettings: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getConversationBotSetting: $state => conversationId => {
    return $state.settings[conversationId] || null;
  },
  getInboxBotSetting: $state => inboxId => {
    return $state.inboxSettings[inboxId] || null;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  fetchConversationSetting: async ({ commit }, conversationId) => {
    commit(types.SET_CONVERSATION_BOT_UI_FLAG, { isFetching: true });
    try {
      const { data } = await conversationBotSettingsAPI.get(conversationId);
      commit(types.SET_CONVERSATION_BOT_SETTING, {
        conversationId,
        setting: data,
      });
    } catch (error) {
      // Not yet created — that's fine
    } finally {
      commit(types.SET_CONVERSATION_BOT_UI_FLAG, { isFetching: false });
    }
  },

  updateConversationSetting: async (
    { commit },
    { conversationId, ...data }
  ) => {
    commit(types.SET_CONVERSATION_BOT_UI_FLAG, { isUpdating: true });
    try {
      const { data: setting } = await conversationBotSettingsAPI.update(
        conversationId,
        data
      );
      commit(types.SET_CONVERSATION_BOT_SETTING, {
        conversationId,
        setting,
      });
      return setting;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_CONVERSATION_BOT_UI_FLAG, { isUpdating: false });
    }
  },

  fetchInboxSetting: async ({ commit }, inboxId) => {
    try {
      const { data } = await inboxBotSettingsAPI.get(inboxId);
      commit(types.SET_CONVERSATION_BOT_SETTING, { inboxId, setting: data });
    } catch (error) {
      // Ignore
    }
  },

  updateInboxSetting: async ({ commit }, { inboxId, ...data }) => {
    commit(types.SET_CONVERSATION_BOT_UI_FLAG, { isUpdating: true });
    try {
      const { data: setting } = await inboxBotSettingsAPI.update(inboxId, data);
      commit(types.SET_CONVERSATION_BOT_SETTING, { inboxId, setting });
      return setting;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_CONVERSATION_BOT_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_CONVERSATION_BOT_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_CONVERSATION_BOT_SETTING](
    $state,
    { conversationId, inboxId, setting }
  ) {
    if (conversationId) {
      $state.settings = { ...$state.settings, [conversationId]: setting };
    }
    if (inboxId) {
      $state.inboxSettings = { ...$state.inboxSettings, [inboxId]: setting };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
